module.exports = __webpack_public_path__ + "04_mustache_grey.63c2e40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/04_mustache_grey.png
// module id = K8UE
// module chunks = 0